<template>
  <div>
    <img src="@/assets/images/antimationBg.png" style="width:100%" />
    <div class="goHistoryBg">
      已为
      <span>{{ fortune.count }} </span>
      位用户测算
      <router-link
        class="goHistoryBtn"
        :to="{ name: linkToHistoryName }"
      ></router-link>
    </div>
    <img src="@/assets/images/twoIm.png" alt="" class="imTUs" />
    <img src="@/assets/images/oneIm.png" alt="" class="imTUs" />
    <img src="@/assets/images/newThree.png" alt="" class="imTUs" />
    <div class="article-birth" style="margin: 0 auto 10px">
      <div>
        <div class="userInputBg">
          您的姓名：<input
            type="text"
            placeholder="请输入你的姓名"
            id="userName"
            v-model="userName"
          />
        </div>
        <div class="userInputBg">
          出生日期：<input
            type="text"
            id="birthday"
            placeholder="请输入阳历生日"
            v-model="birthday"
          />
          <p
            class="inputClick"
            onclick="document.getElementById('birthday').click();"
          ></p>
        </div>
        <div class="gender-select userInputBg">
          您的性别：
          <label for="man">
            <input
              type="radio"
              name="sex"
              value="1"
              id="man"
              v-model="gender"
            />
            <i></i>男
          </label>
          <label for="woman">
            <input
              type="radio"
              name="sex"
              checked
              value="2"
              id="woman"
              v-model="gender"
            />
            <i></i>
            女
          </label>
        </div>
      </div>
      <p
        class="hintMessage"
        style="text-align: center;color: #F95B39;width:55%;margin: 5px auto;"
      >
        {{ inputHint }}
      </p>
      <div class="goPayBtn" v-on:click="submitToPreview()">开始测算</div>
      <router-link :to="{ name: linkToHistoryName }">
        <p
          style="text-align: center;width:55%;margin: 0 auto;height: 40px;line-height: 40px;"
        >
          查看历史订单页 &gt;
        </p>
      </router-link>
    </div>
    <img
      src="@/assets/images/persent.png"
      class="imTUs"
      style="width:90%;margin: 15px auto;"
    />
    <img src="@/assets/images/threeIm.png" alt="" class="imTUs imMar" />
    <img src="@/assets/images/fourIm.png" alt="" class="imTUs imMar" />
    <img src="@/assets/images/sixIm.png" alt="" class="imTUs imMar" />
    <div class="commentShow imMar">
      <p class="CommentOne">
        已有
        <span>{{ fortune.count }}</span>
        人进行测试，
        <span class="textRed">97%</span>
        的用户认为很准
      </p>
      <p class="CommentTwo">
        由占卜大师吴明光及所在团队桃桃喜倾力打造，质量保障，请放心购买。
      </p>
      <img src="@/assets/images/fiveImStar.png" alt="" class="percent" />
      <div>
        <div class="commentBg">
          <img src="@/assets/images/comment1.png" alt="" />
          <img src="@/assets/images/comment2.png" alt="" />
          <img src="@/assets/images/comment3.png" alt="" />
          <img src="@/assets/images/comment1.png" alt="" />
        </div>
      </div>
    </div>
    <img
      src="@/assets/images/persent.png"
      class="imTUs"
      style="width:90%;margin: 15px auto;"
    />
    <div class="article-call" v-on:click="linkToService()">
      <p>如果需要帮助，请点击此处联系我们的</p>
      <p class="callSer">我们的售后客服</p>
    </div>
    <div id="article-foot" style="display: none;">
      <div class="goPayBtnDown" v-on:click="scrollToBirthdayInput()"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ROUTE_CONST } from '../constants/router-constant'

export default {
  name: 'Home',
  data() {
    return {
      linkToHistoryName: ROUTE_CONST.HISTORY.name,
      userName: null,
      birthday: null,
      gender: 2
    }
  },
  mounted: function() {
    window.onscroll = scrollListener

    var birthday = new datePicker()
    birthday.init({
      trigger: '#birthday',
      type: 'date',
      onSubmit: function() {},
      onClose: function() {}
    })

    try {
      TtxTrack.track('xing-ming-v2', 'FORTUNE_INDEX')
    } catch (e) {
      // console.log(e)
    }
  },
  methods: {
    submitToPreview: function() {
      document.querySelector('.goPayBtn').style.backgroundPosition = '0 100%'
      if (this.formValid) {
        var payload = {}
        payload.userName = this.userName
        payload.birthday = this.birthday
        payload.gender = this.gender
        this.$store.commit('fortune/setRequestData', payload)

        this.$router.push(ROUTE_CONST.PREVIEW.path)
      } else {
        if (!this.birthday || this.userName == '' || this.userName === null) {
          document.querySelector('.goPayBtn').style.backgroundPosition = '0 0'
          document.querySelector('.goPayBtn').style.backgroundSize = '100% 200%'
          alert('请输入生日与姓名')
        } else if (this.userName.length < 2 || this.userName.length > 4) {
          document.querySelector('.goPayBtn').style.backgroundPosition = '0 0'
          document.querySelector('.goPayBtn').style.backgroundSize = '100% 200%'
          alert('请输入你的名字哦~注意姓名长度为2-4的中文字符')
        }
      }
    },
    linkToService: function() {
      this.$router.push({ name: 'Service' })
    },
    scrollToBirthdayInput: function() {
      document.documentElement.scrollTop =
        document.querySelector('.article-birth').offsetTop - 100
      document.body.scrollTop =
        document.querySelector('.article-birth').offsetTop - 100
      document.querySelector('#article-foot').style.display = 'none'
    }
  },
  computed: {
    ...mapState({
      fortune: state => state.fortune
    }),
    inputHint: function() {
      var hintString = null
      if (this.userName && !isChinese(this.userName)) {
        hintString = '请输入你的名字哦~注意姓名长度为2-4的中文字符'
      } else if (this.birthday && this.userName) {
        hintString = '为了确保测试结果准确性，请仔细核对信息。'
      }
      return hintString
    },
    formValid: function() {
      if (this.userName && !isChinese(this.userName)) {
        return false
      } else if (this.birthday && this.userName) {
        if (this.userName.length <= 4 && this.userName.length >= 2) {
          return true
        }
      }
      return false
    }
  }
}

var scrollListener = function() {
  try {
    var t = document.documentElement.scrollTop || document.body.scrollTop
    if (t >= document.querySelectorAll('.imTUs')[2].offsetTop + 600) {
      document.querySelector('#article-foot').style.display = 'block'
    } else {
      document.querySelector('#article-foot').style.display = 'none'
    }
  } catch (ex) {}
}
var isChinese = function(s) {
  var ret = true
  for (var i = 0; i < s.length; i++) {
    ret = ret && s.charCodeAt(i) >= 10000 //判断文本字符的unicode值
  }
  return ret
}
</script>

<style scoped>
.goHistoryBtn {
  width: 60px;
  height: 42px;
  background: url('../assets/images/history.png') 0 0 no-repeat;
  background-size: 100%;
  position: absolute;
  right: 5%;
  top: 0;
}
.article-birth {
  background: url('../assets/images/birthBg.png') 0 0 no-repeat;
  background-size: 100% 100%;
  width: 100%;
  padding: 10% 0 5%;
}
.userInputBg {
  margin: 5px auto;
  position: relative;
  clear: both;
  background: url('../assets/images/inputBg.png') 0 0 no-repeat;
  background-size: 100% 100%;
  width: 80%;
  padding: 1% 3%;
  line-height: 10vw;
  height: 12vw;
  color: #714f27;
  font-size: 16px;
}
.goPayBtn {
  width: 75%;
  height: 40px;
  background: url('../assets/images/goPayBtn.png') 0 0 no-repeat;
  background-size: 100% 200%;
  margin: 0 auto;
  display: block;
  line-height: 40px;
  color: #fff;
  text-align: center;
}
.commentShow {
  width: 96%;
  display: block;
  margin: 0 auto;
  padding: 5%;
  background: url('../assets/images/fiveIm.png') 0 0 no-repeat;
  background-size: 100% 100%;
  border: 1px solid transparent;
}
.imMar {
  margin: 10px auto;
}

.article-call p:last-child {
  background: url('../assets/images/call.png') 0 0 no-repeat;
  background-size: 18%;
  display: inline-block;
  padding-left: 25px;
}
.goPayBtnDown {
  width: 85%;
  height: 100%;
  max-width: 360px;
  background: url('../assets/images/goPayBtnDown.png') 0 0 no-repeat;
  background-size: 200%;
  margin: 1% auto;
}

#birth,
#birthday {
  background: url('../assets/images/more.png') 100% 50% no-repeat;
  background-size: 7%;
}
</style>
